module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/setting/setting.component.scss
// module id = ./src/app/modules/setting/setting.component.scss
// module chunks = main